import _ from "lodash";

export type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? (T[P] extends Array<any> ? DeepPartial<T[P]> : DeepPartial<T[P]>) : T[P];
};

export const deepDiff = <T extends object>(obj1: T, obj2: T): DeepPartial<T> => {
  return _.transform(
    obj2,
    (result, val2, key) => {
      const val1 = obj1[key];
      if (!_.isEqual(val2, val1)) {
        if (_.isObject(val2) && _.isObject(val1) && !_.isArray(val2) && !_.isArray(val1)) {
          (result as any)[key] = deepDiff(val1, val2);
        } else {
          (result as any)[key] = val2;
        }
      }
    },
    {} as DeepPartial<T>
  );
};
